import React from 'react'
import { Container } from 'components/Layout'

import cn from 'classnames'
import s from './FullWidthSection.scss'
import sLay from 'styles/modules/layout.scss'

export default props => {
  const { color, children, className, style, fullHeight, ...otherProps } = props
  return (
    <div
      className={cn(s.section, sLay['layout-column'], { [s.fullHeight]: fullHeight }, className)}
      style={style}
      {...otherProps}
    >
      <Container
        className={cn(sLay['layout-column'], sLay['layout-align-center'], sLay.flex, s.inner)}
      >
        {children}
      </Container>
    </div>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/FullWidthSection/FullWidthSection.jsx